import Icon from '../components/Icon.vue'

Icon.register({
  'user-ninja': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M325.4 289.2L224 390.6 122.6 289.2C54 295.3 0 352.2 0 422.4V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V422.4C448 352.2 394 295.3 325.4 289.2zM32 192C59.3 192 83.8 180.5 101.2 162.3 116.3 216.2 165.2 256 224 256 294.7 256 352 198.7 352 128S294.7 0 224 0C173.6 0 130.4 29.4 109.5 71.8 92.1 47.8 64 32 32 32 32 65.4 49.1 94.8 75.1 112 49.1 129.2 32 158.6 32 192zM176 96H272C289.7 96 304 110.3 304 128H144C144 110.3 158.3 96 176 96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-ninja.js
// module id = lq5y
// module chunks = 144